import React from "react";
import GenericModal from "components/MainApp/atoms/Modals/GenericModal";
import { Button } from "@material-ui/core";
import DownloadIcon from '@mui/icons-material/Download';

import styles from "./PrintErrorModal.module.scss";
import i18n from "i18n";
const PrintErrorModal = ({ open, handleClose, handleContinue, handleDownloadTags, showContinue = true}) => {
    const content = <div className={styles["print-error-content"]}>
        <div className={styles["icon-div"]}><i className={`${styles["icon-error"]} icon-iconos_alerta`}></i></div>
        <div className={styles["print-error-title"]}>{i18n.t("printing.error")}</div>
        <Button
            className={styles["color-upload"]}
            component="label"
            role={undefined}
            tabIndex={-1}
            startIcon={<DownloadIcon />}
            onClick={handleDownloadTags}
        >
            {i18n.t("download.generated.tags")}
        </Button>
        <div className={styles["print-error-subtitle"]}>{i18n.t("error.while.printing")}</div>
        <div className={styles["print-error-buttons"]}>
          <div className={styles["btn-wrapper"]}>
              <Button className={styles["btn-reimprimir"]} onClick={handleClose}>{i18n.t("retry")}</Button>

              {showContinue && <Button className={styles["btn-close"]} onClick={handleContinue}>{i18n.t("continue").toUpperCase()}</Button>}

          </div>
        </div>

    </div>
    return (
      <div className={styles["print-error-container"]}>
          <GenericModal
            open={open}
            content={content}
            handleClose={handleClose}></GenericModal>
      </div>
    );
}


export default PrintErrorModal;
